import React, { useState, useContext } from 'react';
import { I18nContext } from "./shared";
import { Rating, RatingStar } from "flowbite-react";
import { useCreateReview } from "./useCreateReview";

export default function ReviewsForm({ appId }: { appId: number }) {
  const i18n = useContext(I18nContext);
  const t: any = i18n;
  const createReview = useCreateReview(appId);
  const [author, setAuthor] = useState('');
  const [text, setText] = useState('');
  const [score, setScore] = useState(3);

  const handleCreate = async () => {
    if (!author.trim()) {
      alert(t.form?.author_label + ' ' + t.form.required_field)
      return;
    }
    if (!text.trim()) {
      alert(t.form?.text_label + ' ' + t.form.required_field)
      return;
    }
    await createReview({ variables: { author, text, score, appId: appId } as any });
    setAuthor('');
    setText('');
    setScore(3);
  };

  return (
    <div className="mt-4">
      <h4 className="text-lg font-semibold mb-3 text-gray-900 dark:text-white">{t.write_review ?? 'Write a review'}</h4>

      <form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          handleCreate();
        }}
        className="bg-white dark:bg-gray-800 p-4 rounded border shadow-sm"
      >
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label htmlFor="review-author" className="text-sm font-medium text-gray-700 dark:text-gray-200">
              {t.form?.author_label ?? t.form?.author_placeholder ?? 'Author'}
            </label>
            <input
              id="review-author"
              className="mt-1 block w-full border rounded px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={author}
              onChange={e => setAuthor(e.target.value)}
              placeholder={t.form?.author_placeholder ?? 'Your name'}
              aria-label={t.form?.author_placeholder ?? 'Your name'}
              required
            />
          </div>

          <div>
            <label htmlFor="review-text" className="text-sm font-medium text-gray-700 dark:text-gray-200">
              {t.form?.text_label ?? t.form?.text_placeholder ?? 'Review'}
            </label>
            <textarea
              id="review-text"
              rows={4}
              className="mt-1 block w-full border rounded px-3 py-2 text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={text}
              onChange={e => setText(e.target.value)}
              placeholder={t.form?.text_placeholder ?? 'Write your review here'}
              aria-label={t.form?.text_placeholder ?? 'Write your review here'}
              required
            />
          </div>

          <div className="flex items-center justify-between">
            <div>
              <Rating size="lg" defaultValue={3}>
                {Array.from({ length: 5 }).map((_, index) => (
                  <RatingStar key={index} filled={index < score} onMouseOver={() => setScore(index + 1)} data-testid={`star-${index}`} />
                ))}
              </Rating>
            </div>

            <div>
              <button
                type="submit"
                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
              >
                {t.form?.submit_button ?? 'Submit'}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}